import loadable from '@loadable/component'

export default [
  {
    path: '/pk',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-Pk-home" */ '~/pages/Pk/pages/home')
    ),
  },
  {
    path: '/pk/rule',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-Pk-rule" */ '~/pages/Pk/pages/rule')
    ),
  },
  {
    path: '/pk/pkHomeList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Pk-pkHomeList" */ '~/pages/Pk/pages/pkHomeList'
        )
    ),
  },
  {
    path: '/pk/rewardRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Pk-rewardRule" */ '~/pages/Pk/pages/rewardRule'
        )
    ),
  },
]
